import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  HostListener
} from "@angular/core";
import { ModalService } from "../../../utilities/modal/modal.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TwoFactorAuthService } from "../two-factor-auth.service";
import { ITwoFactorModel } from "../twoFactorModel";

@Component({
  selector: "verify-code",
  templateUrl: "./verify-code-modal.component.html",
  styleUrls: ["./verify-code-modal.component.scss"]
})
export class VerifyCodeModalComponent implements OnInit {
  @Input() modalId: string;
  @Input() contract: any;
  payloadData: ITwoFactorModel;
  @ViewChild("errorDiv") errorDiv: ElementRef;
  @ViewChild("inputCode") inputCode: ElementRef;
  showForm: boolean;
  verifyCodeFormGroup: FormGroup;
  constructor(
    private modalService: ModalService,
    public twoFactorAuthService: TwoFactorAuthService
  ) {}
  ngOnInit() {
    this.twoFactorAuthService.loading = true;
    this.showForm = true;
    this.payloadData = this.twoFactorAuthService.getPayLoadData();
    this.verifyCodeFormGroup = new FormGroup({
      code: new FormControl("", [Validators.required])
    });
    this.resendACode(false);
    // if (this.inputCode) {
    //   setTimeout(() => {
    //     this.inputCode.nativeElement.focus();
    //   }, 120);
    // }
  }

  close(event: any) {
    this.contract = null;
    this.twoFactorAuthService.verifyCode = false;
    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.serviceFail = null;
    this.modalService.close(this.modalId);
    this.twoFactorAuthService.loading = true;
  }

  submitCode() {
    this.close(event);
  }

  resendACode(notOnLoad?: boolean) {
    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.success = [];
    this.twoFactorAuthService.loading = true;
    this.twoFactorAuthService.sendOneTimeCode("StepUp").subscribe(
      data => {
          if (notOnLoad) {
            this.twoFactorAuthService.success.push({
              message: "Your new code has been sent successfully."
            });
            this.setFocus();
          } else {
            setTimeout(() => {
              this.inputCode.nativeElement.focus();
            });
          }
          this.twoFactorAuthService.loading = false;
      },
      error => {
        this.twoFactorAuthService.loading = false;
        if (
          error.error &&
          error.error.responseHeader &&
          error.error.responseHeader.errorDetails.fieldError[0].fieldCode ===
            "DSC_0317" &&
          error.error.responseHeader.errorDetails.fieldError[0].fieldMessage.startsWith(
            "ResetCodeRetryLimitException"
          )
        ) {
          this.twoFactorAuthService.error.push({
            message:
              "You have exceeded the number of code requests." +
              " " +
              "Please enter an existing code or wait thirty minutes and try again."
          });
          // this.twoFactorAuthService.loading = false;
        } else {
          this.showForm = false;
          this.twoFactorAuthService.error.push({
            message:
              "There was an error sending the code. Please try again later."
          });
        }
        this.setFocus();
      }
    );
  }

  onSubmit() {
    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.success = [];
    this.twoFactorAuthService.loading = true;

    this.twoFactorAuthService
      .verifyOneTimeCode(
        this.verifyCodeFormGroup.controls["code"].value,
        "StepUp"
      )
      .subscribe(
        data => {
          this.twoFactorAuthService.getHrtAuth().subscribe(
            res => {
              if (
                res &&
                res["hrtFlag"] &&
                res["hrtFlag"].toLowerCase() === "allow"
              ) {
                this.openInNewTab(this.contract.contractDetailLink);
                this.modalService.close(this.modalId);
              } else {
                this.errorHandling();
              }
              this.twoFactorAuthService.loading = false;
            },
            error => {
              this.twoFactorAuthService.loading = false;
              this.errorHandling();
            }
          );
        },
        error => {
          this.twoFactorAuthService.loading = false;
          this.errorHandling();
        }
      );
  }

  private setFocus() {
    setTimeout(() => {
      if (this.errorDiv) this.errorDiv.nativeElement.focus();
    });
  }

  errorHandling() {
    this.twoFactorAuthService.attemptCounter--;
    if (this.twoFactorAuthService.attemptCounter === 0) {
      this.twoFactorAuthService.logout();
    } else {
      this.twoFactorAuthService.error.push({
        message: "Could not verify code. Please try again."
      });
    }
    this.setFocus();
    this.twoFactorAuthService.loading = false;
  }
  openInNewTab(url) {
    var win = window.open(url, "_blank", "rel=noopener,noreferrer");
    //win.focus();
  }
}
